export default {
    data   : function () {
        return {
            toolbarSimple: [
                ['style_h1', ['h1']],
                ['style_h2', ['h2']],
                ['style_h3', ['h3']],
                // ['style_h4', ['h4']],
                ['font1', ['bold']],
                // ['font2', ['underline']],
                ['font3', ['italic']],
                // ['font4', ['strikethrough']],
                // ['para', ['ul']],
                // ['para2', ['ol']],
                ['mybutton', ['rewrite']],
                ['mybutton2', ['keepwriting']],
            ],

            subTaskProcessing: {
                needCaptcha     : true,
                taskId          : null,
                sended          : false,
                completed       : false,
                processing      : false,
                interval        : null,
                progress        : null,
                state           : null,
                sendError       : null,
                sendErrorCode   : null,
                cancelToken     : null,
                taskUrl         : '/write/prepare',
                previousRequests: {},
                resolveCallback : null,
                rejectCallback  : null,
            }
        }
    },

    computed: {
        subTaskInProgress() {
            return this.subTaskProcessing.sended && !this.subTaskProcessing.completed;
        },
    },
    methods: {
        sendSubTask(data) {
            if (window.Laravel.loadProd && this.subTaskProcessing.needCaptcha
                && (
                    (typeof window.stripe !== "undefined" && !!!window.stripe.ha)
                    || (typeof window.stripe === "undefined")
                )
            ) {
                this.$modalRecaptcha.open()
                    .then((response) => {
                        if (response.status == 'verify') {
                            data.recaptcha_response = window.Laravel.cT + ':' + response.token;
                            this._sendSubTask(data);
                        } else if (typeof this.subTaskProcessing.rejectCallback === "function") {
                            this.subTaskProcessing.rejectCallback();
                        }
                    })
                    .catch(() => {
                        if (typeof this.subTaskProcessing.rejectCallback === "function") {
                            this.subTaskProcessing.rejectCallback();
                        }
                    });
            } else {
                this._sendSubTask(data);
            }
        },

        _sendSubTask(data) {
            if (this.subTaskProcessing.sended) {
                if (typeof this.subTaskProcessing.rejectCallback === "function") {
                    this.subTaskProcessing.rejectCallback();
                }
                return false;
            }

            this.subTaskProcessing.sended = true;

            axios({
                method: 'POST',
                url   : this.subTaskProcessing.taskUrl,
                data  : data,
            }).then(response => {
                this.onSuccessSendSubTask(response);
                this.successSendProcessingSubTask(response);
                this.onAfterSuccessSendProcessingSubTask(response);
            }).catch(error => {
                this.onErrorSendSubTask(error);
                this.errorSendProcessingSubTask(error);
            });
        },

        onSuccessSendSubTask(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onAfterSuccessSendProcessingSubTask(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onErrorSendSubTask(error) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        successSendProcessingSubTask(response) {
            let result = response.data;

            if (result.queue) {
                this.subTaskProcessing.taskId = result.task_id;

                // need investigate - can't catch this situation
                if(this.subTaskProcessing.taskId === null) {
                    this.subTaskProcessing.processing = false;
                    this.subTaskProcessing.completed = true;
                } else {
                    this.subTaskProcessing.completed = false;
                    this.subTaskProcessing.processing = true;
                    this.startCheckingProcessingSubTask(response);
                }

            } else {
                this.subTaskProcessing.processing = false;
                this.subTaskProcessing.taskId = result.task_id;
                this.subTaskProcessing.completed = true;

                if (typeof this.subTaskProcessing.resolveCallback === "function") {
                    this.subTaskProcessing.resolveCallback(response);
                }
            }
        },

        errorSendProcessingSubTask(error) {
            let response = error.response;

            this.subTaskProcessing.processing = false;
            this.subTaskProcessing.completed = false;
            this.subTaskProcessing.taskId = null;
            if (response.status == 422 && response.data && response.data.errors && response.data.errors.recaptcha_response) {
                this.subTaskProcessing.sendError = response.data.errors.recaptcha_response[0];
                this.subTaskProcessing.sendErrorCode = 422;
            } else {
                this.subTaskProcessing.sendError = (response.data.message)
                    ? response.data.message
                    : this.trans('tool-main.Unable process file'); // todo need show error message
                this.subTaskProcessing.sendErrorCode = (response.data.error_code)
                    ? response.data.error_code
                    : null; // need for logic showing errors
            }
            if (typeof this.subTaskProcessing.rejectCallback === "function") {
                this.subTaskProcessing.rejectCallback(response);
            }
        },

        resetSubTask() {
            this.beforeResetSubTask();

            this.subTaskProcessing.sended = false;
            this.subTaskProcessing.needCaptcha = true;
            this.subTaskProcessing.completed = false;
            this.subTaskProcessing.processing = false;
            this.subTaskProcessing.progress = null;
            this.subTaskProcessing.state = null;
            this.subTaskProcessing.sendError = null;
            this.subTaskProcessing.sendErrorCode = null;
            this.subTaskProcessing.cancelToken = null;
            this.subTaskProcessing.taskId = null;
            this.subTaskProcessing.resolveCallback = null;
            this.subTaskProcessing.rejectCallback = null;

            this.afterResetSubTask();
        },

        startCheckingProcessingSubTask() {
            clearInterval(this.subTaskProcessing.interval);
            let intervalDuration = 10000;

            if ((typeof window.stripe !== "undefined") && parseInt(window.stripe.ha)) {
                intervalDuration = 3000;
            }
            this.subTaskProcessing.interval = setInterval(() => {
                this._checkProcessingRequestSubTask();
            }, intervalDuration)
            this._checkProcessingRequestSubTask();
        },

        _checkProcessingRequestSubTask() {
            axios({
                method: 'POST',
                url   : '/task/progress/' + this.subTaskProcessing.taskId,
                data  : {},
            }).then(response => {
                this._successProcessingActionsSubTask(response);
            }).catch(error => {
                let response = error.response;
                if ([504, 524].indexOf(response.status) === -1) { // exclude error timeout, more likely for dev cluster
                    this.errorProcessingSubTask(error);
                }
            });
        },

        _successProcessingActionsSubTask(response) {
            this.onBeforeSuccessProcessingSubTask(response);
            this.successProcessingSubTask(response);
            this.onAfterSuccessProcessingSubTask(response);
        },

        onBeforeSuccessProcessingSubTask(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onAfterSuccessProcessingSubTask(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        successProcessingSubTask(response) {
            let result = response.data;

            this.subTaskProcessing.state = result.state;
            this.subTaskProcessing.progress = result.progress;

            if (this.subTaskProcessing.state === 'completed') {
                clearInterval(this.subTaskProcessing.interval);
                this.subTaskProcessing.processing = false;
                this.subTaskProcessing.completed = true;

                if (typeof this.subTaskProcessing.resolveCallback === "function") {
                    this.subTaskProcessing.resolveCallback(response);
                }
            }
        },

        beforeErrorProcessingSubTask(error) {
            // you should override this if needed
        },

        errorProcessingSubTask(error) {
            this.beforeErrorProcessingSubTask(error);
            let response = error.response;

            clearInterval(this.subTaskProcessing.interval);
            this.subTaskProcessing.processing = false;
            this.subTaskProcessing.completed = false;
            this.subTaskProcessing.taskId = null;
            this.subTaskProcessing.progress = null;
            this.subTaskProcessing.state = null;
            this.subTaskProcessing.sendError = (response.message) ?
                response.message
                : (response.data.message ? response.data.message : this.trans('tool-main.Unable process file')); // todo need show error message
            this.subTaskProcessing.sendErrorCode = (response.error_code)
                ? response.error_code
                : (response.data.error_code ? response.data.error_code : null); // need for logic showing errors

            if (typeof this.subTaskProcessing.rejectCallback === "function") {
                this.subTaskProcessing.rejectCallback(response);
            }

            this.afterErrorProcessingSubTask(error);
        },

        afterErrorProcessingSubTask(error) {
            // you should override this if needed
        },

        beforeResetSubTask() {
            // you should override this if needed
        },

        afterResetSubTask() {
            // you should override this if needed
        },


        rewriteText(selectedText, resolve, reject) {
            this.resetSubTask();

            if (typeof reject === "function") {
                this.subTaskProcessing.rejectCallback = (response) => {
                    if (response) {
                        this.subTaskProcessing.previousRequests['rewrite_service'] = Date.now();
                    }
                    reject();
                }
            }
            if (typeof resolve === "function") {
                this.subTaskProcessing.resolveCallback = (response) => {
                    this.subTaskProcessing.previousRequests['rewrite_service'] = Date.now();
                    if (response && response.data.text) {
                        resolve(response.data.text);
                    } else if (typeof reject === "function") {
                        reject();
                    }
                }
            }

            if ((this.subTaskProcessing.previousRequests['rewrite_service'] + 15 * 1000) < Date.now()
                && selectedText.length < 300
            ) {
                this.subTaskProcessing.needCaptcha = false;
            } else {
                this.subTaskProcessing.needCaptcha = true;
            }

            this.sendSubTask({
                mode  : 'rewrite_service',
                prompt: selectedText,
            });
        },

        keepWriteText(data, resolve, reject) {
            this.resetSubTask();

            if (typeof reject === "function") {
                this.subTaskProcessing.rejectCallback = (response) => {
                    reject();
                }
            }
            if (typeof resolve === "function") {
                this.subTaskProcessing.resolveCallback = (response) => {
                    if (response && response.data.text) {
                        resolve(response.data.text);
                    } else if (typeof reject === "function") {
                        reject();
                    }
                }
            }

            this.sendSubTask({
                mode  : 'continue_write_service',
                ...data,
            });
        },
    },
}


